// Exports
// =============================================================================
export default {
    // reNotLength: /[^\w\%\.\-]/,
    reNotLength: /[^\w%.-]/,
    reNumber   : /^[-+]?[0-9]*\.?[0-9]+/,
    reUnit     : /[a-z|%]+$/,
    rounding   : 5
};
